import moment from 'moment';
import momentTimezone from 'moment-timezone';

export const formatTravelDateForEdit = form => {
  if (!form.date) {
    const start = moment.utc(form.start_at);
    const end = moment.utc(form.end_at);
    let endAmPm;
    let endHours;
    if (end.isValid()) {
      endAmPm = end.format('a');
      endHours = end.format('h');
    }
    return {
      date: moment.utc(form.start_at),
      startTimeMins: start.format('m'),
      startTimeHrs: start.format('h'),
      startTimeAmPm: start.format('a'),
      endTimeMins: end.isValid() ? end.format('m') : undefined,
      endTimeHrs: endHours,
      endTimeAmPm: endAmPm,
    };
  }
  return undefined;
};

export const formatTravelDate = form => {
  const dateString = moment.utc(form.date, 'MM-DD-YYYY').format('MM-DD-YYYY');
  const start = moment.utc(
    `${dateString} ${form.startTimeHrs}:${form.startTimeMins} ${form.startTimeAmPm}`,
    'MM-DD-YYYY h:mm a'
  );
  const end =
    form.endTimeHrs && form.endTimeMins !== ''
      ? moment.utc(
          `${dateString} ${form.endTimeHrs}:${form.endTimeMins} ${form.endTimeAmPm}`,
          'MM-DD-YYYY h:mm a'
        )
      : '';
  if (end !== '' && end.isBefore(start)) {
    end.add(1, 'd');
  }
  const startTime = start.format();
  const endTime = end !== '' ? end.format() : undefined;
  return Object.assign({}, form, {
    start_at: startTime,
    end_at: endTime,
    timezone: momentTimezone.tz.guess(),
  });
};

export const formatEventDate = form => {
  const dateString = moment.utc(form.date, 'MM-DD-YYYY').format('MM-DD-YYYY');
  const startAt = moment.utc(
    `${dateString} ${form.start_at.hour}:${form.start_at.minute}`,
    'MM-DD-YYYY h:mm a'
  );
  const endAt = form.end_at
    ? moment.utc(`${dateString} ${form.end_at.hour}:${form.end_at.minute}`, 'MM-DD-YYYY h:mm a')
    : '';
  if (endAt !== '' && endAt.isBefore(startAt)) {
    endAt.add(1, 'd');
  }
  const timezone = momentTimezone.tz.guess();
  const formattedForm = Object.assign({}, form, {
    start_at: startAt.format(),
    end_at: endAt !== '' ? endAt.format() : null,
    end_time: endAt !== '' ? form.end_time : null,
    timezone,
  });
  return formattedForm;
};

export const formatDateForEdit = form => {
  if (!form.date) {
    const start = moment.utc(form.start_at);
    const end = moment.utc(form.end_at);

    return {
      date: moment.utc(form.start_at),
      start_at: { hour: start.format('H'), minute: start.format('m') },
      end_at: end.isValid() ? { hour: end.format('H'), minute: end.format('m') } : undefined,
    };
  }
  return undefined;
};

export const formatVirtualDateForEdit = form => {
  if (!form.date) {
    const start = moment.utc(form.start_at);

    return {
      date: moment.utc(form.start_at),
      start_at: `${start.format('h')}:${start.format('mm')} ${start.format('a')}`,
    };
  }
  return undefined;
};

// TODO: Tests
export const formatVirtualEventStart = ({ date, time }) => {
  let dateString;
  if (moment.isMoment(date)) {
    dateString = date.format('MM-DD-YYYY');
  } else {
    dateString = moment.utc(date, 'MM/DD/YYYY').format('MM-DD-YYYY');
  }
  const formatted = moment
    .utc(`${dateString} ${time}`, 'MM-DD-YYYY h:mm a')
    .format('YYYY-MM-DD[T]HH:mm:ss[Z]');
  return formatted;
};

export const parseStartTime = (zoomStartTime, timezone) => {
  if (!zoomStartTime || !timezone) return {};
  const formattedTime = moment.utc(zoomStartTime).format('YYYY-MM-DD[T]HH:mm:ss');
  const formattedDate = moment(formattedTime).format('L');
  const startTime = moment(formattedTime).format('h:mm a');
  const tzAbbr = moment().tz(timezone).format('z');
  return { date: formattedDate, startTime, tzAbbr };
};

export const getFormattedEndTime = (startTime, duration) => {
  if (!startTime || !duration) return undefined;
  const startMoment = moment.utc(startTime, 'YYYY-MM-DD[T]HH:mm:ss[Z]');
  return startMoment.add(60 * 1000 * duration).format('YYYY-MM-DD[T]HH:mm:ss[Z]');
};

export const getEventDuration = (startTime, endTime) => {
  if (!startTime || !endTime) return undefined;
  const startMoment = moment.utc(startTime, 'YYYY-MM-DD[T]HH:mm:ss[Z]');
  const endMoment = moment.utc(endTime, 'YYYY-MM-DD[T]HH:mm:ss[Z]');
  return endMoment.diff(startMoment, 'minutes');
};

export const formatNewDate = date => (date ? moment.utc(date) : moment.utc());



// WEBPACK FOOTER //
// ./src/util/formDataUtil.js